
/**
 * jQuery menumaker 2016/2017 by cg/bs.
 */
(function ($) {
    "use strict";

    $.fn.kbMenuMaker = function(options) {
        var cssmenu = $(this);
        var settings = $.extend({
            toggle: "#mobile-navbar-toggle",
            format: "dropdown",
            sticky: false,
            more: "more",
            breakpoint: 767
        }, options);

        return this.each(function() {
            var $this   = $(this);
            var $toggle = getToggleButton($this, settings);

            $toggle.on("click", function () {
                // $(this).toggleClass("menu-opened"); // <- D.O.N.T.!!! ERROR-PRONE!!!
                var mainmenu = $this.find(".nav-level-1");
                if (mainmenu.hasClass("open")) {
                    mainmenu.removeClass("open");
                    mainmenu.parent().removeClass('showme');
                    $(this).removeClass("menu-opened");
                    $('#page-wrapper').removeClass("mobile-blur");
                } else {
                    mainmenu.addClass("open");
                    mainmenu.parent().addClass('showme');
                    $(this).addClass("menu-opened");
                    $('#page-wrapper').addClass("mobile-blur");
                }
            });

            if (settings.format === "multitoggle") {
                multiToggle($this, settings);
            } else {
                cssmenu.addClass("dropdown");
            }

            if (settings.sticky === true) {
                cssmenu.css("position", "fixed");
            }

            onWindowResize($this, settings);

            return $(window).on("resize", function() { onWindowResize($this, settings) });
        });
    };


    /**
     * Calculates window size independent of any scrollbars.
     */
    var calcWindowSize = function() {
        var $body = $("body");
        var width = $body.css("width", "100vw");
        $body.css("width", ""); // remove 100vw again or else we may have scrollbars
        return width;
    };


    var onWindowResize = function($navbar, settings) {
        var mediasize = settings.breakpoint;
        var winSize = calcWindowSize();


        if (winSize > mediasize) {
            $navbar.find(".navbar-nav").removeClass("open");
            // $navbar.find(".navbar-collapse").removeClass("collapse in");
            $navbar.find(class2Selector(settings.more)).removeClass("submenu-opened");
            getToggleButton($navbar, settings).removeClass("menu-opened");
        } else {
            // $navbar.find(".navbar-collapse").addClass("collapse");
        }
    };


    function getToggleButton($navbar, settings) {
        var $toggleButton = null;
        if (settings.toggle[0] === "#") {
            $toggleButton = $(settings.toggle);
        } else {
            $toggleButton = $navbar.find(settings.toggle);
        }
        return $toggleButton;
        // return (settings.toggle[0] === "#" ? $(settings.toggle) : $navbar.find(settings.toggle));
    }


    function multiToggle($navbar, settings) {
        $navbar.find(".dropdown").prepend("<span class=\"" + settings.more + "\"></span>");
        $navbar.find(class2Selector(settings.more)).on("click", function () {
            if ($(this).siblings(".dropdown-menu").hasClass("open")) {
                $(this).siblings(".dropdown-menu").removeClass("open").slideToggle();
                $(this).removeClass("submenu-opened");
            } else {
                $(this).siblings(".dropdown-menu").addClass("open").slideToggle();
                $(this).addClass("submenu-opened");
            }
        });
    }


    function class2Selector(classes) {
        var s = classes.trim();
        if (s.length > 0) {
            return "." + s.replace(/( )+/g, " ").replace(/ /g, ".");
        }
        return "";
    }

})(jQuery);


$(document).ready(function() {


    var $mainNav = $("#navigation");
    var $mainNavMenu = $mainNav.find("#kb-menu-dropdown");

    // Default kbMenuMaker instance
    $mainNavMenu.kbMenuMaker({
        format: "multitoggle",
        // toggle: "#mobile-navbar-toggle",
        more: "more fa fa-chevron-down"
    });

    // Meta-Top ins MainMenu klonen
    $("#meta-navigation .nav-wrapper>ul>li").each(function() {
        var cloned = $(this).clone();
        cloned.addClass('show-sm-max');
        if (cloned.hasClass('dropdown')) {
            cloned.prepend('<span class="more fa fa-chevron-down"></span>');
            cloned.find('span').on("click", function () {
                if ($(this).siblings(".dropdown-menu").hasClass("open")) {
                    $(this).siblings(".dropdown-menu").removeClass("open").slideToggle();
                    $(this).removeClass("submenu-opened");
                } else {
                    $(this).siblings(".dropdown-menu").addClass("open").slideToggle();
                    $(this).addClass("submenu-opened");
                }
            });
        }
        cloned.appendTo('#navigation >.frame .nav-wrapper>ul');
    });



    setTimeout(function() {
        $('ul.nav-level-1').each(function() {
            resetActiveNavBar($(this));
        });
    }, 250);
});

$(document).on('mouseover', 'li.nav-level-1>a', function() {
    var pos = getNavItemPositions($(this));

    $(this).parent().parent().parent().find('.active-marker').css({
        'left' : pos['res'],
        'width' : pos['width'],
        'opacity' : 1
    });
});

$(document).on('mouseleave', 'ul.nav-level-1', function () {
    resetActiveNavBar($(this));
});

function resetActiveNavBar(navul) {
    var activeMarker = navul.parent().find('.active-marker');
    var activeNav = navul.find('li.nav-level-1.active:not(".show-sm-max")>a');

    if (activeNav.length > 0) {
        var pos = getNavItemPositions(activeNav);

        activeMarker.css({
            'left' : pos['res'],
            'width' : pos['width'],
            'opacity' : 1
        });
        console.log('if teil');
    } else {
        activeMarker.css({
            'left' : -25,
            'width' : 0,
            'opacity' : 0
        });
        console.log('else teil');
    }
}
function getNavItemPositions(element) {
    var c = element;
    var p = c.parent().parent();

    var childPos = c.offset();
    var parentPos = p.offset();
    // 20 magic number ist padding left von .collapse
    var res = childPos.left - parentPos.left + 20;
    var width = c.outerWidth();

    var positions = [];
    positions["res"] = res;
    positions["width"] = width;

    return positions;
}
